import validatorjs from 'validatorjs';
import _get from 'lodash/get';
import { CUSTOM_ERROR_MESSAGES, LANGUAGES } from './constants/app';
import { transformErrorMessages } from './utils/CommonUtils';
import { isStrongPassword } from './utils/strongPassword';
import { сheckingMinDateIsCorrect, сheckingMaxDateIsCorrect, checkingWhenLess18Age } from '@bytebrand/fe-ui-core-autobahn/utils';
import form from '../components/pages/CheckoutPage/CheckoutStepper/Content/ContactInformation/formConfig';
import { default as borrowerForm } from '../components/pages/CheckoutPage/CheckoutStepper/Content/PaymentDetails/formConfig';
// TODO: replace this function with class wrapper
// create separate methods for registering custom validation rules and for setting custom error messages
const Validator = () => {
    validatorjs.register('iban', value => typeof value === 'string' && /^DE[0-9]{2}(?:\s?[0-9]{4}){4}\s?[0-9]{2}$/.test(value), 'Please enter the valid IBAN');
    validatorjs.register('bic', value => typeof value === 'string' && /^[A-Z]{4}DE[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value), 'Please enter the valid BIC');
    validatorjs.register('date_dd.mm.yyyy', (value) => value && value.match(/^[0-9]{1,2}(\.)[0-9]{1,2}(\.)[0-9]{4}$/), 'Selected date is not in the format dd.mm.yyyy.');
    validatorjs.register('dd/MM/yyyy', (value) => {
        const errorCondition = value &&
            value !== 'birthday' &&
            value.toString() !== 'Invalid Date' &&
            сheckingMinDateIsCorrect(value) &&
            сheckingMaxDateIsCorrect(value) &&
            checkingWhenLess18Age(value);
        return errorCondition;
    }, '* Please enter a valid date of birth');
    // value.match(/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/)
    validatorjs.register('password', 
    // Old validation rule:
    // (value: string) => value && value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W\_])[a-zA-Z0-9\W\_]{8,}$/),
    value => value && !!(`${value}`.match(/^.{8,}$/)), `Use 8 or more characters`);
    // ADV-268: the profile's new password (CredentialsForm), matching its hint; see strongPassword.ts
    validatorjs.register('password_strong', value => isStrongPassword(value), 'At least 10 characters, including one digit and one special character.');
    validatorjs.register('phone', value => typeof value === 'string' && /^\+\d{6,19}$/.test(value), 'Between 6 and 20 characters');
    // length validation is temporary removed due to hotfix ACF-2694
    validatorjs.register('phone_countryCode', value => typeof value === 'string' && /^(\+?\d{1,3}|\d{1,4})$/.test(value), '1 to 3 digits');
    validatorjs.register('phone_areaCode', value => typeof value === 'string' && /^\d{2,5}$/.test(value), '2 to 5 digits');
    validatorjs.register('phone_phoneNumber', value => typeof value === 'string' && /^\d{3,12}$/.test(value), '3 to 12 digits');
    validatorjs.register('firstName', value => typeof value === 'string' && /^[\s\p{L}-]+$/u.test(value), 'Please enter letters only');
    validatorjs.register('lastName', value => typeof value === 'string' && /^[\s\p{L}-]+$/u.test(value), 'Please enter letters only');
    // validatorjs.register(
    //   'bateryCapacity',
    //   value => value && value.match(/^[0-9,.]/),
    //   'Please enter a valid value'
    // );
    validatorjs.register('postcode', value => typeof value === 'string' && /^\d{5}$/.test(value), '5 digits');
    validatorjs.register('vin_code', (value) => value && value.match(/^[A-HJ-NPR-Z0-9]{17}$/i), 'Please enter the valid VIN-code');
    validatorjs.register('borrower_email', (value) => value && borrowerForm.$('email').value !== form.$('email').value, 'emailError');
    validatorjs.register('internet_address', (value) => value && value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/), 'Please enter the valid internet address');
    validatorjs.register('discount_code', (value) => value && /^[a-zA-Z0-9-_]+$/.test(value), 'This symbol is not allowed');
    LANGUAGES.forEach((lang) => {
        validatorjs.setMessages(lang.value, transformErrorMessages(validatorjs.getMessages(lang.value), lang.value));
    });
    // inject custom error messages into validatorjs
    LANGUAGES.forEach(({ value: lang }) => {
        const customMessage = _get(CUSTOM_ERROR_MESSAGES, lang, null);
        if (!customMessage)
            return null;
        validatorjs.setMessages(lang, Object.assign({}, validatorjs.getMessages(lang), customMessage));
    });
};
export default Validator;
